import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Table, Column, Cell } from 'fixed-data-table-2';
import 'fixed-data-table-2/dist/fixed-data-table.css';
import './Css/Grid.css';
import './Css/Keiyaku.css';
import { Modal, ModalHeader, ModalFooter, ModalBody } from 'reactstrap';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import Tooltip from '@material-ui/core/Tooltip';
import SyousaiModal from "./SyousaiModal";
import * as Keiyaku from './Saga/Keiyaku';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { green } from '@material-ui/core/colors';
import Checkbox, { CheckboxProps } from '@material-ui/core/Checkbox';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';


const { MuiPickersUtilsProvider, KeyboardDatePicker } = require('@material-ui/pickers');
var moment = require('moment-timezone');
var SortTypes = {
  ASC: 'ASC',
  DESC: 'DESC',
};


const GreenCheckbox = withStyles({
  root: {
    color: green[400],
    '&$checked': {
      color: green[600],
    },
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />);


function reverseSortDirection(sortDir) {
  return sortDir === SortTypes.DESC ? SortTypes.ASC : SortTypes.DESC;
}
class SortHeaderCell extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      index: 0,
    }
    this._onSortChange = this._onSortChange.bind(this);
  }

  render() {
    var { onSortChange, sortDir, children, ...props } = this.props;
    return (
      <Cell {...props} onClick={this._onSortChange}>
        {children} {sortDir ? (sortDir === SortTypes.DESC ? <ArrowDropDownIcon /> : <ArrowDropUpIcon />) : ''}
      </Cell>
    );
  }

  _onSortChange(e) {
    e.preventDefault();
    if (this.props.onSortChange) {
      this.props.onSortChange(
        this.props.columnKey,
        this.props.sortDir ?
          reverseSortDirection(this.props.sortDir) :
          SortTypes.DESC
      );
    }
  }
}
const columns =
  [
    { key: 'send_at', name: '送信日', width: 120, resizable: true },
    { key: 'target', name: '対象', width: 120, resizable: true },
    { key: 'title', name: 'タイトル', width: 300, resizable: true },
    { key: 'contents', name: '内容', width: 600, resizable: true },
    { key: 'user_name_all', name: '作成者', width: 150, resizable: true },
  ]

const Target = ({ column, props, rowIndex }) =>
  <div>
    <Cell style={{ whiteSpace: "nowrap" }} >
      {props[rowIndex]['target_type'] == 1 ? "建物全体" :
        props[rowIndex]['Room_Name'] + "号室"
      }
    </Cell>
  </div>

const Dates = ({ column, props, rowIndex }) =>
  < Cell style={{ whiteSpace: "nowrap" }} >
    {props[rowIndex][column.key] ? moment(props[rowIndex][column.key]).utc().format('YYYY-MM-DD') : ""}
  </Cell >

const Base = ({ column, props, rowIndex, contentstoggle }) =>
  <div onClick={() => contentstoggle(rowIndex)}>
    <div>
      <Cell style={{ whiteSpace: "nowrap" }} > {props[rowIndex][column.key]} </Cell>
    </div>
  </div>

class CustomerList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      columns: columns,
      reflash: false,
      colSortDirs: {},
      contentstoggle: false,
      title: "",
      contents: ""
    };

    this._onColumnResizeEndCallback = this._onColumnResizeEndCallback.bind(this);
    this._onSortChange = this._onSortChange.bind(this);
    this.contentstoggle = this.contentstoggle.bind(this);

  }
  _onColumnResizeEndCallback(newColumnWidth, columnKey) {

    let columnsset = this.state.columns.map(function (value) {
      if (value.key === columnKey) {
        value.width = newColumnWidth
      }
      return value
    })

    this.setState({ columns: columnsset })

  }





  _onSortChange(columnKey, sortDir) {

    let seisan_follow_search_list = this.props.news_list;
    seisan_follow_search_list.sort((indexA, indexB) => {
      var valueA = indexA[columnKey];
      var valueB = indexB[columnKey];
      var sortVal = 0;
      if (valueA > valueB) {
        sortVal = 1;
      }
      if (valueA < valueB) {
        sortVal = -1;
      }

      if (!valueA && !valueB) {
        sortVal = 0
      }
      if (!valueA) {
        sortVal = -1
      }
      if (!valueB) {
        sortVal = 1
      }


      if (sortVal !== 0 && sortDir === SortTypes.DESC) {
        sortVal = sortVal * -1;
      }

      return sortVal;
    });
    this.setState({
      // sortedDataList: new DataListWrapper(sortIndexes, this._dataList),
      colSortDirs: {
        [columnKey]: sortDir,
      },
    });
  }


  contentstoggle(index) {

    if (this.state.contentstoggle == false) {
      this.setState({
        title: this.props.news_list[index].title,
        contents: this.props.news_list[index].contents
      })
    }

    this.setState({ contentstoggle: !this.state.contentstoggle })
  }


  render() {

    return (
      <div id="Keiyaku">
        <Table
          rowHeight={40}
          rowsCount={this.props.news_list.length}
          // rowsCount={10}
          onColumnResizeEndCallback={this._onColumnResizeEndCallback}
          width={window.innerWidth - 260}
          height={window.innerHeight - 400}
          headerHeight={30}>
          {columns.map(function (value, i) {
            return <Column
              columnKey={value.key}
              header={<SortHeaderCell
                onSortChange={this._onSortChange}
                sortDir={this.state.colSortDirs[value.key]}
                style={{ whiteSpace: "nowrap" }}>{value.name}</SortHeaderCell>}

              // cell={({ rowIndex, ...props }) => (<Cell style={{ whiteSpace: "nowrap" }} >{this.props.seisan_follow_list[rowIndex][value.key]}</Cell>)}
              cell={({ rowIndex, ...props }) => (
                value.key === "target" ? <Target column={value} props={this.props.news_list} rowIndex={rowIndex}></Target>
                  : value.key === "send_at" ? <Dates column={value} props={this.props.news_list} rowIndex={rowIndex}></Dates>
                    : <Base column={value} props={this.props.news_list} rowIndex={rowIndex} contentstoggle={this.contentstoggle}></Base>
              )}
              width={this.state.columns.filter(a => a.key === value.key)[0].width}
              isResizable={true}
              fixed={value.frozen}

            />
          }, this)}
        </Table >


        < Modal isOpen={this.state.contentstoggle} toggle={this.contentstoggle} size="kokyaku" fade={false}>

          <div>
            <TextField
              id="standard-read-only-input"
              label="タイトル"
              defaultValue={this.state.title}
              InputProps={{
                readOnly: true,
              }}
              style={{ margin: 10 }}
              variant="standard"
            />
          </div>

          <div>
            <TextField
              id="outlined-read-only-input"
              label="内容"
              fullWidth
              multiline
              rows={15}
              variant="outlined"
              defaultValue={this.state.contents}
              style={{ marginTop: 10 }}
              InputProps={{
                readOnly: true,
              }}
            />
          </div>

        </Modal >



      </div >
    );
  }
};


//export  default CustomerList;
const mapStateToProps = (state) => {
  return {
    news_list: state.Keiyaku.news_list,

  }
}
function mapDispatchToProps(dispatch) {
  return {
    get_detail(state) {
      dispatch(Keiyaku.get_detail(state))
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomerList);